import { css } from "@emotion/react";
import { ManagementViewTitle } from "../bits/ManagementViewTitle";
import { useTitle } from "../hooks/useTitle";
import { RecentActivity } from "../patterns/RecentActivity";

export const MyRecentSearches = () => {
  useTitle("Recent searches | Compass");

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 24px;
        gap: 24px;
      `}
    >
      <ManagementViewTitle text="My recent searches" />
      <div
        css={({ breakpoints }) => css`
          padding: 0 70px;
          width: 100%;

          @media (max-width: ${breakpoints.values.xl}px) {
            padding: 0;
          }
        `}
      >
        <RecentActivity />
      </div>
    </div>
  );
};
